import React from "react";
import { Modal } from "../../secondary/Modal";
import styles from "./createRiskAssessment.module.scss";
import { CreateRiskAssessmentFormView } from "./createRiskAssessmentFormView";
import { useSelector } from "react-redux";

export const CreateRiskAssessment = ({ modalClose }) => {
  const checkRiskAssessmentScale = useSelector((state) => state.user.userDetails?.customerSettings?.riskAssessmentScale ?? "norton");

  return (
    <Modal
      modalOpen={true}
      modalClose={modalClose}
      heading={"Risk Assessment"}
      className={styles.assessment_modal}
      modalSize={styles.custom_modal_size}
    >
      <div className={styles.spacing}>
        {checkRiskAssessmentScale && (
          <CreateRiskAssessmentFormView styles={styles} checkRiskAssessmentScale={checkRiskAssessmentScale} handleCancel={modalClose} />
        )}
      </div>
    </Modal>
  );
};
